import React, { useEffect } from "react";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "../../components/WhyhostView/WhyHostBase.css";
import HeroBanner from "../../components/WhyhostView/HeroBanner";
import FeaturesSection from "../../components/WhyhostView/Featurecard";
import StepsSection from "../../components/WhyhostView/Stepssection";
import ComparisonTable from "../../components/WhyhostView/ComparisonTable";
import FAQSection from "../../components/WhyhostView/FaqSection";
import CtaBanner from "../../components/WhyhostView/CtaBanner";
import Scroll from "react-scroll";

let Element = Scroll.Element;

function WhyHostView() {
  useEffect(() => {
    if (window.location.hash === "#faq") {
      const faqElement = document.getElementById("faq");
      if (faqElement) {
        faqElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, []);

  return (
    <div className={cx(s["why-host-view"], "whyhost-page")}>
      <Element className="element">
        <HeroBanner />
        <FeaturesSection />
        <StepsSection />
        <ComparisonTable />
        <FAQSection name="faq" id="faq" />
        <CtaBanner />
      </Element>
    </div>
  );
}

export default withStyles(s)(WhyHostView);

